import { keyToActionTypes } from 'src/utils/keyToActionTypes';

export const authActionTypes: any = keyToActionTypes(
  {
    SET_ACCOUNT_INFO: null,
    LOG_OUT: null,
    LOGGED_OUT: null,
  },
  'AUTH'
);
